import '../../resources/css/frame/MainMenu.scss';
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { checkTableAuth } from '../../components/common/access-auth';
import { doActivePage, doChangeSimpleMode, doChangeDetailMode } from '../../actions/menu/index';
import Loading from '../../components/common/Loading';

class MainMenu extends Component {
  constructor(props) {
    super(props);

    this.updateActiveKey = this.updateActiveKey.bind(this);

    this.state = {
      activeKey: null
    }
  }

  selectMenu = (name) => {
    const { doActivePage } = this.props;
    doActivePage(name);
  }

  renderToggleMenuMode = (mode, iconPre, text, iconMin, iconMax) => {

    const { doChangeSimpleMode, doChangeDetailMode } = this.props;

    const areaIconPre = <span className={iconPre}></span>;
    const areaIconMinClass = iconMin + ' ml-auto';
    const areaIconMin = (
      <span className={areaIconMinClass} onClick={doChangeSimpleMode}></span>
    );
    const areaIconMax = (
      <span className={iconMax} onClick={doChangeDetailMode}></span>
    )

    if (mode === 'simple-mode') {
      return (
        <Nav className="main-item" variant="main-title">
          {areaIconMax}
        </Nav>
      );
    } else {
      return (
        <Nav className="main-item" variant="main-title">
          {areaIconPre}
          {text}
          {areaIconMin}
        </Nav>
      );
    }
  }

  renderMainItem = (mode, icon, text) => {
    if (mode === 'simple-mode') {
      return (
        <Nav variant="main-item">
          <span className={icon}></span>
          <div className="line"></div>
        </Nav>
      );
    } else {
      return (
        <Nav variant="main-item">
          <span className={icon}></span>
          <div className="line">{text}</div>
        </Nav>
      );
    }
  }

  renderSubItem = (name, icon, opts) => {
    const { accountRole, roleTableAuth } = this.props;

    let retContent = (<div className={'area-' + name}></div>);
    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 1)) {
      retContent = (
        <Nav.Link onSelect={() => this.selectMenu(opts['url'])} className="sub-item" eventKey={ name }>
          <span className={icon} />
          <div className={name + "-bg"}>
            <label className={name + "-lable hide"}>{opts.text}</label>
          </div>
        </Nav.Link>
      );
    }

    return retContent;
  }

  updateActiveKey = () => {
    const { /*activePage, navName,*/ formType } = this.props;

    let activeKey = formType;
    // if (navName) {
    //   activeKey = navName;
    //   // if (formType) {
    //   //   activeKey += '/' + formType;
    //   // }
    // }

    // let chooseBar = (this.props.chooseBar) ? this.props.chooseBar : "";
    this.setState({
      activeKey: activeKey
    });
  }

  componentDidMount() {
    // if call render will do this method
    this.updateActiveKey();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if props change will call this method
    const { activePage, location } = this.props;

    if (prevProps.activePage !== activePage) {
      this.updateActiveKey();
    }

    if (prevProps.location.pathname !== location.pathname) {
      this.updateActiveKey();
    }
  }

  render() {
    const { activePage } = this.props;
    const { activeKey } = this.state;

    if (!activePage) {
      // return loading if no has active page
      return (
        <Loading loading={true}></Loading>
      )
    }

    
    let rfMapContent = this.renderSubItem('floorplan', 'icon-rf', { "url": "rf_map/floorplan", "text": "Floor Plans" });
    let floorPlanProjectContent = this.renderSubItem('project', 'icon-floor-plan-list', { "url": "rf_map/project", "text": "Projects" });

    return (
      <Nav defaultActiveKey={activeKey} activeKey={activeKey} variant="main-menu" className="main-menu flex-column">
        <div className="sub-menu">
          {floorPlanProjectContent}
          {rfMapContent}
        </div>
      </Nav>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { navName, formType } = ownProps.match.params;

  return {
    displayMode: state.menuReducers.displayMode,
    activePage: state.menuReducers.activePage,
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    navName: navName,
    formType: formType
  }
}

export default withRouter(connect(
  mapStateToProps,
  { doActivePage, doChangeSimpleMode, doChangeDetailMode }
)(MainMenu))